import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

const urlLogin = 'https://ebtapps.com/';
//const urlLogin = 'http://127.0.0.1:5500/index.html/';

const AccessGate = ({ children }) => {

    const [searchParams] = useSearchParams();
    const [isAuthorized, setIsAuthorized] = useState(null); // null = loading
    

    const validarKey = async ( key ) => {

        try {

            const payload = { key : key };
            // const { data } = await axios.post(`http://localhost:3309/api/login`, payload);
            const { data } = await axios.post(`https://apitimeinzone.ebtapps.com/api/login`, payload);

            console.log("Respuesta de validación:", data);

            if (data.success) {

                // Guarda token en sessionStorage
                sessionStorage.setItem('ebt_token_time_in_zone', data.token); // Usa el token que quieras guardar

                // Elimina ?key= de la URL
                const urlWithoutKey = window.location.origin + window.location.pathname;
                window.location.replace(urlWithoutKey);

                setIsAuthorized(true);

            } else {
                
                window.location.replace(urlLogin);

            }

        } catch (error) {

            console.error("Error en validación de key", error);
            Swal.fire("Error", "No se pudo validar el acceso", "error");

            window.location.replace(urlLogin);


        }

    };

    useEffect(() => {

        const keyFromUrl = searchParams.get('key');
        const ebtToken = sessionStorage.getItem('ebt_token_time_in_zone');

        if(keyFromUrl){

            validarKey(keyFromUrl);

        } else if (ebtToken) {

            setIsAuthorized(true);
            return;
            
        } else {

            window.location.replace(urlLogin);

        }

    }, []);

    if (isAuthorized === null) {

        return <div style={{ textAlign: 'center', marginTop: 40 }}>Validando acceso...</div>;

    }

    return <>{children}</>;

}

export default AccessGate